import { FixedMarkerOverrides, FloatingMarker } from 'baseui/map-marker';
import { memo } from 'react';
import { Marker } from 'react-map-gl/mapbox';
import { useRecoilValue } from 'recoil';
import { useCamera } from '../../../hooks/useCamera';
import useUpdateEffect from '../../../hooks/useUpdateEffect';
import { evaluationDistanceLngLatsState, evaluationDistanceState } from '../../../storage/evaluations';

function EvaluationMarkers() {
  const evaluationDistance = useRecoilValue(evaluationDistanceState);
  const lngLats = useRecoilValue(evaluationDistanceLngLatsState);
  const { fitToLngLats } = useCamera();

  const markerOverrides: FixedMarkerOverrides = {
    Root: {
      style: () => ({
        transform: `translateY(-50%)`,
      }),
    },
  };

  useUpdateEffect(() => {
    if (!lngLats.length) return;

    fitToLngLats(lngLats);
  }, [lngLats, fitToLngLats]);

  if (!evaluationDistance) return null;

  const { firstAsset, secondAsset } = evaluationDistance;

  return (
    <>
      <Marker
        latitude={firstAsset.position_latitude}
        longitude={firstAsset.position_longitude}
      >
        <FloatingMarker
          label={'Punto A'}
          overrides={markerOverrides}
          size="small"
          anchorType="square"
        />
      </Marker>
      <Marker
        latitude={secondAsset.position_latitude}
        longitude={secondAsset.position_longitude}
      >
        <FloatingMarker
          label={'Punto B'}
          overrides={markerOverrides}
          size="small"
          anchorType="square"
        />
      </Marker>
    </>
  );
}

export default memo(EvaluationMarkers);
